export default __webpack_public_path__ + "static/media/bg-blue.13dae62f.png";